import {
  FETCH_ASSIGNED_CREATIVES,
  APPEND_ASSIGNED_CREATIVES,
  COMPLETE_ASSIGNED_CREATIVES,
  PAUSE_ASSIGNED_CREATIVES,
  RESUME_ASSIGNED_CREATIVES
} from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";
import { normalizeDataByField } from "../utils/normalize";

const initialState = {
  isLoading: true,
  isLoadingMore: false,
  byId: {},
  allIds: [],
  fetchKey: null,
  // Resume-state: nextPageToken is set whenever we pause (abort mid-load)
  // or after a successful page that has more results. isComplete flips
  // true only when the loop finishes naturally.
  nextPageToken: null,
  isComplete: false
};

export const dcmAssignedCreatives = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSIGNED_CREATIVES:
      switch (action.status) {
        case SUCCESS: {
          let { byId, allIds } = normalizeDataByField(action.data, "id");
          return {
            ...state,
            isLoading: false,
            isLoadingMore: allIds.length > 0 && !!action.nextPageToken,
            byId,
            allIds,
            nextPageToken: action.nextPageToken || null
          };
        }
        case FAILURE:
          return {
            ...state,
            isLoading: false,
            isLoadingMore: false,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        case PENDING:
          return {
            ...state,
            isLoading: true,
            isLoadingMore: false,
            byId: {},
            allIds: [],
            fetchKey: action.fetchKey || null,
            nextPageToken: null,
            isComplete: false
          };
        default:
          return state;
      }
    case APPEND_ASSIGNED_CREATIVES: {
      let appended = normalizeDataByField(action.data, "id");
      return {
        ...state,
        isLoadingMore: !!action.nextPageToken,
        byId: { ...state.byId, ...appended.byId },
        allIds: [...state.allIds, ...appended.allIds],
        nextPageToken: action.nextPageToken || null
      };
    }
    case COMPLETE_ASSIGNED_CREATIVES:
      return {
        ...state,
        isLoading: false,
        isLoadingMore: false,
        nextPageToken: null,
        isComplete: true
      };
    case PAUSE_ASSIGNED_CREATIVES:
      // Aborted mid-load. Preserve what we have; remember where to resume.
      return {
        ...state,
        isLoading: false,
        isLoadingMore: false,
        nextPageToken: action.nextPageToken || state.nextPageToken,
        isComplete: false
      };
    case RESUME_ASSIGNED_CREATIVES:
      // Picking up where the last abort stopped; don't wipe loaded data.
      return {
        ...state,
        isLoadingMore: true
      };
    default:
      return state;
  }
};
